import { network } from 'services/network';

export const getActivityRelations = (params) => {
    const url = `api/bo/getActivityRelations?taskId=${params.taskId}`;

    return network.get(url).then((response) => {
        return response.data;
    });
};
